export function groupArray(arr, n) {
  let result = []
  for (let i = 0; i < arr.length; i += 3) {
    let group = []

    for (let j = 0; j < n; j++) {
      if (i + j < arr.length) {
        group.push(arr[i + j])
      }
    }

    result.push(group)
  }
  return result
}
